import { Avatar, Box } from 'reoil'
import useUpload, { UploadResponse } from '../../hooks/api/useUpload'
import avatar from '../../assets/images/avatar.png'

interface UploadAvatarProps {
  initialSrc?: string
  onChange?: (value: UploadResponse)=>void
}

const UploadAvatar: React.FC<UploadAvatarProps> = ({initialSrc=avatar, onChange}) => {

  const { handleChange, response, file } = useUpload(onChange)

  const objectUrl = file ? URL.createObjectURL(file) : ''

  return(
    <Box className='UploadAvatar' my={2}>
      <label htmlFor='upload-avatar'>
        <Box row center left>
          <Avatar size={50} src={response?.publishUrl || objectUrl || initialSrc} />
          <Box fontSize={0} fontWeight='bold' color='text.caption' ml={2}>上传免冠证件照</Box>
        </Box>
      </label>

      <input id='upload-avatar' style={{display: 'none'}} type="file" name='file' onChange={handleChange} accept='image/*' />
    </Box>
  )
}

export default UploadAvatar
